
export enum TypeSocketConsentPassData {
    REQUEST_CONSENT = 'REQUEST_CONSENT',
    SEND_CONSENT_FORM_DATA = 'SEND_CONSENT_FORM_DATA',
    PROGRESSING = 'PROGRESSING',
    PROGRESSED = 'PROGRESSED',
    SEND_SIGNATURE = 'SEND_SIGNATURE',
    COMPLETE_CONSENT = 'COMPLETE_CONSENT',
    CANCEL_CONSENT = 'CANCEL_CONSENT',
}

export enum TypeSocketConsentActors {
    CASHIER = 'CASHIER',
    CUSTOMER = 'CUSTOMER',
}

export type SocketConsentData<Modal = TypeSocketConsentPassData> = {
    shopId: string;
    customerId: string;
    action?: Modal,
    actor: TypeSocketConsentActors,
    data?: any;
};
